import React, { PureComponent } from 'react';
import cn from 'classnames';
import { TextInput2 } from '@el8/vital';

import styles from './PasswordInput.less';

type PasswordInputProps = {
  error: string | boolean;
  name: string;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  style?: React.CSSProperties;
  value?: string;
};

enum InputTypes {
  password = 'password',
  text = 'text',
}

type PasswordInputState = {
  isFocused: boolean;
  type: InputTypes;
};

export default class PasswordInput extends PureComponent<PasswordInputProps, PasswordInputState> {
  state = {
    isFocused: false,
    type: InputTypes.password,
  };

  handleFocus = (event: React.FocusEvent<HTMLInputElement>): void => {
    this.setState({ isFocused: true });

    if (this.props.onFocus) {
      this.props.onFocus(event);
    }
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>): void => {
    this.setState({ isFocused: false });

    if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  };

  handleToggleMouseDown = (event: React.MouseEvent<HTMLElement>): void => {
    if (this.state.isFocused) {
      event.preventDefault();
    }
  };

  handleToggleClick = (): void => {
    this.setState(state => ({
      type: state.type === InputTypes.password ? InputTypes.text : InputTypes.password,
    }));
  };

  render(): JSX.Element {
    const { type, isFocused } = this.state;
    return (
      <span className={styles.container}>
        <TextInput2
          {...this.props}
          type={type}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className={cn(styles.toggle, (isFocused || !!this.props.value) && styles.withValue)}
          onMouseDown={this.handleToggleMouseDown}
          onClick={this.handleToggleClick}
          role="button"
          tabIndex={0}
        >
          {type === InputTypes.password ? 'Show' : 'Hide'}
        </div>
      </span>
    );
  }
}
